export class UtronUserEntity {
  id;
  identityId;
  firstName;
  lastName;
  createdDate;
  deleted;
  image;
  userSites;
  cars;
  carUserTokens;
  userAdditionalData;
  constructor(
    id,
    identityId,
    firstName,
    lastName,
    image,
    userSites,
    cars,
    carUserTokens,
    userAdditionalData
  ) {
    this.id = id;
    this.identityId = identityId;
    this.firstName = firstName;
    this.lastName = lastName;
    this.createdDate = new Date();
    this.deleted = false;
    this.image = image;
    this.userSites = userSites;
    this.cars = cars;
    this.carUserTokens = carUserTokens;
    this.userAdditionalData = userAdditionalData;
  }
}
